import { Box, Grid, Typography, styled } from "@mui/material";
import { LongText, SpaceBetweenBox } from "components/GeneralStyled";

import CopyToClipboard from "components/CopyToClipboard";
import { DefaultUrlWeb } from "config/Configuration";
import Modal from "components/Modal";
import NumberFormats from "components/NumberFormats";
import React from "react";
import State from "./State";
import { useSelector } from "react-redux";

function WithdrawOrDepositDetailModal({ open, onClose }) {
  const singleHistory = useSelector(
    (state) => state.wallet.singleHistory?.data
  );

  const isFiat = singleHistory?.listFiat;

  return (
    <Modal
      onClose={onClose}
      maxWidth="xs"
      open={open}
      title={`${singleHistory?.side} Details`}
    >
      <Grid container>
        <Grid item xs={12}>
          <HeaderBox>
            <State data={singleHistory} />

            <CoinAmount mt={2}>
              <Typography variant="h6" color="text.secondary">
                Amount
              </Typography>

              <img
                src={DefaultUrlWeb + singleHistory?.coinImageUrl}
                alt={singleHistory?.coinName}
              />

              <Typography color="text.main" variant="h5">
                <NumberFormats value={singleHistory?.amount} />{" "}
              </Typography>
              
                {singleHistory?.coinName}
            </CoinAmount>

            <Typography
              variant="subtitle2"
              color="text.secondary"
              textAlign="right"
            >
              {singleHistory?.date} {singleHistory?.time}
            </Typography>
          </HeaderBox>

          <Box>
            {!isFiat && (
              <SpaceBetweenBox>
                <Typography variant="subtitle1" color="text.secondary">
                  Fee
                </Typography>

                <Typography variant="h6">{singleHistory?.fee}</Typography>
              </SpaceBetweenBox>
            )}

            {singleHistory?.network && !isFiat ? (
              <SpaceBetweenBox>
                <Typography variant="subtitle1" color="text.secondary">
                  Network
                </Typography>

                <Typography variant="h6">{singleHistory?.network}</Typography>
              </SpaceBetweenBox>
            ) : (
              ""
            )}

            {singleHistory?.type && (
              <SpaceBetweenBox>
                <Typography variant="subtitle1" color="text.secondary">
                  Type
                </Typography>

                <Typography variant="h6">{singleHistory?.type}</Typography>
              </SpaceBetweenBox>
            )}

            {singleHistory?.side && (
              <SpaceBetweenBox>
                <Typography variant="subtitle1" color="text.secondary">
                  Side
                </Typography>

                <Typography variant="h6">
                  {isFiat ? singleHistory?.description2 : singleHistory?.side}
                </Typography>
              </SpaceBetweenBox>
            )}

            {singleHistory?.address && !isFiat ? (
              <SpaceBetweenBox>
                <Typography variant="subtitle1" color="text.secondary">
                  Address
                </Typography>

                <AddressBox>
                  {singleHistory?.address ? (
                    <>
                      <LongText variant="subtitle1">
                        {singleHistory?.address}
                      </LongText>

                      <CopyToClipboard value={singleHistory?.address} />
                    </>
                  ) : (
                    "-"
                  )}
                </AddressBox>
              </SpaceBetweenBox>
            ) : (
              ""
            )}

            {(singleHistory?.txId || singleHistory?.description2) && !isFiat ? (
              <SpaceBetweenBox>
                <Typography variant="subtitle1" color="text.secondary">
                  TxID
                </Typography>

                <AddressBox>
                  {singleHistory?.txId || singleHistory?.description2 ? (
                    <>
                      <LongText variant="subtitle1">
                        {singleHistory?.txId || singleHistory?.description2}
                      </LongText>

                      <CopyToClipboard
                        value={
                          singleHistory?.txId || singleHistory?.description2
                        }
                      />
                    </>
                  ) : (
                    "-"
                  )}
                </AddressBox>
              </SpaceBetweenBox>
            ) : (
              ""
            )}

            {singleHistory?.listFiat?.map((item) => (
              <>
                <SpaceBetweenBox>
                  <Typography variant="subtitle1" color="text.secondary">
                    از بانک
                  </Typography>

                  <Typography variant="h6">
                    {item.bankAccountSourceBankName}
                  </Typography>
                </SpaceBetweenBox>

                <SpaceBetweenBox>
                  <Typography variant="subtitle1" color="text.secondary">
                    از شماره حساب
                  </Typography>

                  <Typography variant="h6">
                    {item.bankAccountSourceAccountNumber}
                  </Typography>
                </SpaceBetweenBox>

                <SpaceBetweenBox>
                  <Typography variant="subtitle1" color="text.secondary">
                    صاحب حساب
                  </Typography>

                  <Typography variant="h6">
                    {item.bankAccountDestinationAccountOwnerName}
                  </Typography>
                </SpaceBetweenBox>

                <SpaceBetweenBox>
                  <Typography variant="subtitle1" color="text.secondary">
                    به بانک
                  </Typography>

                  <Typography variant="h6">
                    {item.bankAccountDestinationBankName}
                  </Typography>
                </SpaceBetweenBox>

                <SpaceBetweenBox>
                  <Typography variant="subtitle1" color="text.secondary">
                    به شماره حساب
                  </Typography>

                  <Typography variant="h6">
                    {item.bankAccountDestinationAccountNumber}
                  </Typography>
                </SpaceBetweenBox>

                <SpaceBetweenBox>
                  <Typography variant="subtitle1" color="text.secondary">
                    صاحب حساب
                  </Typography>

                  <Typography variant="h6">
                    {item.bankAccountDestinationAccountOwnerName}
                  </Typography>
                </SpaceBetweenBox>

                <SpaceBetweenBox>
                  <Typography variant="subtitle1" color="text.secondary">
                    مبلغ
                  </Typography>

                  <Typography variant="h6" color="text.main">
                    <NumberFormats value={item.amount} />
                  </Typography>
                </SpaceBetweenBox>

                <SpaceBetweenBox>
                  <Typography variant="subtitle1" color="text.secondary">
                    شماره سند
                  </Typography>

                  <Typography variant="h6">{item.docNumber}</Typography>
                </SpaceBetweenBox>
              </>
            ))}
          </Box>
        </Grid>
      </Grid>
    </Modal>
  );
}

const HeaderBox = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,

  paddingBottom: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const AddressBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
}));

const CoinAmount = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  img: {
    width: "30px",
    height: "30px",
    margin: theme.spacing(0, 1),
  },
}));

export default WithdrawOrDepositDetailModal;
